import dash_api from 'client/js/main/support/dash_api';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { DataAction } from 'client/js/redux/types/dataAction.type';
import type { AdsActivityConfig } from 'shared/types/AdsActivityConfig';

const GetAdsActivityConfigAction = new ReduxAsyncAction<'GET_ADS_ACTIVITY_CONFIG', void, AdsActivityConfig>(
  'GET_ADS_ACTIVITY_CONFIG'
);

GetAdsActivityConfigAction.registerRequest(async () => {
  try {
    const response = await dash_api.get('/v1/ads/analytics/view');
    return { ...response?.data };
    // biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
  } catch (e) {
    return { newActivityTable: true };
  }
});

export const GET_ADS_ACTIVITY_CONFIG = GetAdsActivityConfigAction.actionNamespaceConstants;

export const getAdsActivityConfig = GetAdsActivityConfigAction.request;

export type GetAdsActivityConfigResponseAction = DataAction<typeof GET_ADS_ACTIVITY_CONFIG.response, AdsActivityConfig>;
